import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        py: 20,
        px: 2,
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "5rem", md: "8rem" },
          fontWeight: 800,
          letterSpacing: "-0.04em",
          color: "#1a1a1a",
          lineHeight: 1,
          mb: 2,
        }}
      >
        404
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: "0.65rem", md: "0.7rem" },
          letterSpacing: "0.3em",
          textTransform: "uppercase",
          color: "#525252",
          mb: 1.5,
        }}
      >
        Page Not Found
      </Typography>

      <Typography
        sx={{
          fontSize: "0.85rem",
          color: "#737373",
          mb: 6,
          maxWidth: 360,
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>

      <Button
        onClick={() => navigate("/")}
        variant="outlined"
        disableElevation
        sx={{
          borderColor: "#2a2a2a",
          color: "#737373",
          px: 4,
          py: 1.25,
          fontSize: "0.65rem",
          letterSpacing: "0.12em",
          borderRadius: 0,
          "&:hover": {
            borderColor: "black",
            color: "black",
            bgcolor: "transparent",
          },
        }}
      >
        Back to Shop
      </Button>
    </Box>
  );
};

export default NotFoundPage;
